<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Certifications</h1>
            <p>
                When we say irrigation is our specility, we mean it.
                We are certified by the Irrigation Association as:
                <ul>
                  <li>Irrigation Designer</li>
                  <li>Irrigation Contractor</li>
                  <li>Irrigation Auditor</li>
                  <li>Golf Irrigation Auditor</li>
                </ul>
                We are also state certified backflow technicians.
            </p>
            <img alt="Irrigation Association Certificate" src="../assets/all_certs.jpg" style="width:50%;"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Certifications',
}
</script>